import moment from "moment";
import React from "react";
import { Assessment, Course, Lesson, Skill } from "src/types/coaching/courses";
import { CourseContentSession } from "src/types/coaching/learners";
import { UserGroup } from "src/types/users";

export interface CourseReportContextProps {
  user: null;
  userGroups: UserGroup[] | null;
  skills: Skill[] | null;
  startDate: Date;
  endDate: Date;
}

const startDate = moment().subtract(30, "days").startOf("day").toDate();
const endDate = moment().endOf("day").toDate();

export const CourseReportContext =
  React.createContext<CourseReportContextProps>({
    user: null,
    userGroups: [],
    skills: [],
    startDate: startDate,
    endDate: endDate,
  });
